/*@flow*/
/** @jsx jsx */
import { jsx, css } from '@emotion/core';
// $FlowFixMe
import { ReactComponent as Logo } from 'images/logo.svg';
// $FlowFixMe
import { ReactComponent as LogoCitiesense } from 'images/logo_citiesense.svg';
// $FlowFixMe
import { ReactComponent as LogoNumina } from 'images/logo_numina.svg';
import logoCarmera from 'images/logo_carmera.png';
import logoDBP from 'images/logo_dbp.png';
import { hot } from 'react-hot-loader';
import { BREAKPOINT_MD } from 'store/constants';
import Cell from '../Cell';
import CellHeader from '../Cell/Header';

const ExtLink = props => (
  <a {...props} target="_blank" rel="noopener noreferrer">
    {props.children}
  </a>
);

const Component = () => (
  <Cell col={5} row={2}>
    <CellHeader
      title="Credits"
      styles={`
        color: var(--brand-black);
        background: var(--brand-yellow);
        border-top: solid 1px #ccc;
        border-bottom: solid 1px var(--brand-black);
      `}
    />
    <div
      css={css(`
        display: grid;
        justify-items: center;
        align-items: center;
        height: 100%;
        background: var(--brand-yellow);
        color: var(--brand-black);

        grid-template-rows: 30% 1fr 1fr;
        grid-row-gap: 10px;
      `)}
    >
      <div
        css={css(`
        height: 100%;
        display: grid;
        align-items: center;
        justify-items: center;
      `)}
      >
        <header css={css('text-align: center; padding-top: 50px;')}>
          <h2>
            <b>The Circular City</b>
          </h2>
          <h4>is a partnership between</h4>
        </header>
      </div>
      <div
        css={css(`
          display: grid;
          grid-template-columns: repeat(6, 0.5fr);

          gap: 40px 100px;
          @media(max-width: ${BREAKPOINT_MD.toString()}) {
            grid-column-gap: 100px;
          }

          padding: 10px 20px;
          height: 100%;

          div {
            height: 100%;
            display: grid;
            align-items: center;
            justify-items: center;

            grid-column: span 2;

            @media(max-width: ${BREAKPOINT_MD.toString()}) {
              grid-column: span 4;
            }
          }

          a{
            display: grid;
            align-items: center;
            justify-items: center;
          }
        `)}
      >
        <div>
          <ExtLink href="https://newlab.com/">
            <Logo />
          </ExtLink>
        </div>
        <div>
          <ExtLink href="https://citiesense.com">
            <LogoCitiesense css={css('height: 80px; width: 100%;')} />
          </ExtLink>
        </div>
        <div>
          <ExtLink href="http://numina.co/">
            <LogoNumina css={css('height: 80px; width: 100%;')} />
          </ExtLink>
        </div>
        <div>
          <ExtLink href="https://carmera.co/">
            <img src={logoCarmera} alt="Carmera" css={css('width: 100%;')} />
          </ExtLink>
        </div>
        <div>
          <ExtLink href="http://downtownbrooklyn.com">
            <img src={logoDBP} alt="DBP" css={css('max-width: 50%;')} />
          </ExtLink>
        </div>
      </div>
      <div
        css={css(
          'justify-self: start; align-self: end; padding: 20px 15px; opacity: 0.6;'
        )}
      >
        <small>
          Powered by{' '}
          <ExtLink
            href="https://citiesense.com"
            css={css('color: var(--brand-black);')}
          >
            Citiesense
          </ExtLink>
        </small>
      </div>
    </div>
  </Cell>
);

export default hot(module)(Component);
